// Returns the *active* connected gamepad — the one the user is actually using.
//
// Two problems this solves:
//
// 1. Wrong slot. Chrome does NOT guarantee a pad lands at index 0 — it assigns
//    whatever slot it wants based on connection order and prior pairings. A
//    DualShock/DualSense commonly shows up at index 1, 2 or 3 (see the browser
//    gamepad tester). The old `navigator.getGamepads()[0]` was `null` for those
//    pads, so the controller silently never registered and never drove the bot.
//
// 2. More than one controller. When several pads are connected (e.g. a wheel
//    AND a gamepad), picking the lowest slot is arbitrary and can drive the
//    wrong device. Instead we pick the pad with the most recent input — Chrome
//    bumps `gamepad.timestamp` on every state change, so "newest timestamp" is
//    the one the user just touched. When everything is idle (equal timestamps)
//    we fall back to the lowest index for a stable, deterministic choice.
//
// getGamepads() returns a GamepadList (array-like) whose slots for absent pads
// are `null`, so we Array.from() it and filter to live entries.
export const getActiveGamepad = () => {
	if (typeof navigator === 'undefined') {
		return null;
	}
	const gamepads = navigator.getGamepads
		? navigator.getGamepads()
		: navigator.webkitGetGamepads
			? navigator.webkitGetGamepads()
			: [];
	return Array.from(gamepads)
		.filter((gp) => gp && gp.connected)
		.reduce((best, gp) => {
			if (!best) return gp;
			if (gp.timestamp > best.timestamp) return gp;
			if (gp.timestamp === best.timestamp && gp.index < best.index) return gp;
			return best;
		}, null);
};

export default getActiveGamepad;
